<template>
  <div class="free-downloads">
    <h2 class="downloads__heading">
      {{ heading }}
    </h2>

    <div class="free-downloads__list">
      <div v-for="(column, index) in internalData"
           :key="index"
           class="free-downloads__column">
        <div v-for="item in column.items"
             :key="item.id"
             class="free-downloads__column-item">
          <download-component v-model="item.isSelected"
                              :title="item.title"
                              :name="item.name"
                              :extension="item.extension"
                              :url="item.url"
                              selectable>
            <template v-if="item.text"
                      #description>
              <p class="download__description">
                {{ item.text }}
              </p>
            </template>
          </download-component>
        </div>
      </div>
    </div>

    <div class="free-downloads__actions">
      <button class="downloads__btn btn btn-accent-6"
              @click="handleSelectAll">
        {{ allDownloadsSelected ? "Deselect all" : "Select all" }}
      </button>
      <button class="downloads__btn btn btn-accent-6"
              :disabled="!columns.length"
              @click="onDownloadSelected">
        <loading-spinner v-if="isDownloadInProgress"></loading-spinner>
        <span v-else-if="hasDownloadFailed">
          &#10799;
        </span>
        <span v-else-if="hasDownloadCompleted">
          &#10003;
        </span>
        <span v-else>
          {{ downloadSelectedBtnLabel }}
        </span>
      </button>
    </div>
  </div>
</template>

<script>
import DownloadComponent from "~/Components/Downloads/DownloadContent.vue";
import LoadingSpinner from "~/Components/LoadingSpinner.vue";
import downloadHelperMixin from "~/Scripts/mixins/downloaderMixin";

export default {
  components: {
    LoadingSpinner,
    DownloadComponent
  },
  mixins: [downloadHelperMixin],
  props: {
    columns: {
      type: Array,
      default: () => ( [] )
    },
    heading: {
      type: String,
      default: "Free Downloads"
    },
    downloadSelectedBtnLabel: {
      type: String,
      default: "Download selected files"
    }
  },
  data () {
    return {
      internalData: []
    };
  },
  computed: {
    selectedDownloads () {
      const downloads = this.internalData.flatMap( c => c.items || [] );
      return downloads
        .filter( x => x.isSelected );
    },
    allDownloadsSelected () {
      return this.selectedDownloads.length === this.internalData.flatMap( c => c.items ).length;
    }
  },
  created () {
    this.internalData = this.transformColumns( this.columns );
  },
  methods: {
    onDownloadSelected () {
      this.downloadFiles( this.selectedDownloads ).then( () => {
        this.resetSelectedDownloads();
      } );
    },
    handleSelectAll () {
      if ( this.allDownloadsSelected ) {
        this.resetSelectedDownloads();
      } else {
        this.selectAllDownloads();
      }
    },
    resetSelectedDownloads () {
      this.internalData.forEach( column => {
        column.items.forEach( item => {
          this.$set( item, "isSelected", false );
        } );
      } );
    },
    selectAllDownloads () {
      this.internalData.forEach( column => {
        column.items.forEach( item => {
          this.$set( item, "isSelected", true );
        } );
      } );
    },
    transformColumns ( columns ) {
      return columns.map( column => ( {
        items: column.items.map( item => ( {
          name: item.node.name || this.getFileNameFromUrl( item.value.url ),
          title: item.value.title || "",
          text: item.value.text || "",
          extension: item.node.extension || "",
          url: item.value.url || "",
          isSelected: item.isSelected || false
        } ) )
      } ) );
    }
  }
};
</script>

<style scoped lang="less">
.free-downloads {
  margin: 30px 0;

  @media ( max-width: 991px ) {
    padding: 0;
  }

  &__heading {
    margin-bottom: 15px;

    @media ( max-width: 991px ) {
      margin-bottom: 15px;
    }
  }

  &__list {
    display: flex;
    gap: 1rem;

    @media ( max-width: 991px ) {
      flex-direction: column;
    }
  }

  &__column {
    flex: 1;
    flex-basis: 0;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    max-width: 500px;

    &-item {
      min-height: 7.5rem;
      max-height: fit-content;
    }
  }

  &__actions {
    display: flex;
    gap: 1rem;
    margin-top: 1rem;
  }

  &__btn {
    min-width: 225px;
    margin-bottom: 10px;
  }
}

.loading-spinner {
  color: #fff;

  /deep/ svg {
    font-size: 1em;
  }
}
</style>
